import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GstDetails from "../../../../components/_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../components/_utils/AccountCreationComponents/PanDetails";
import {
  resetPanArchived,
  resetPanUnarchived,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import { panLookUp } from "../../../../redux/features/sharedResources/sharedResources";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import Validation from "../../../../utils/validation";
import "./index.css";
import CommonToast from "../../../../components/_utils/CommonToast";
import ActiveInactiveAssociatePopup from "../../../../components/_utils/ActiveInactiveAssociatePopup";
import ICONS from "../../../../assets/Icons";
import { verifyGST } from "../../../../redux/features/sharedResources/sharedResources";
import ConfirmBtnAccCreation from "../../../../components/_utils/AccountCreationComponents/ConfirmBtnAccCreation";

const FieldForcePanDetails = ({
  verifiedPan,
  panNumber,
  handlePanChange,
  panDetails,
  beneLookData,
  beneLookLoading,
  BenEnableNextButton,
  verifyPANisLoading,
  setIsArchived,
  setIsApproved,
  setIsDennied,
  setIsPending,
  setAccountType,
  type,
  previousId,
  setIsActive,
  beneLookError,
  isBankLinkedToThisPan,

  hideBlock,
  hideCreate,
  nonArchive,
  setPreviousBankNo,
  isLinkedAccount,

  alreadyLinked,
  setPayload,
  payload,
  setShowAccInfo,
  associatedPan,
  setGSTPanExist,
  GSTPanExist,

  setShowPopup,
  accountData,
  accActiveInactiveState,
  setAccActiveInactiveState,
  currentAssociate,
  setCurrentAssociate,
  shouldNextBtnBeEnabled,
  id,
  updateActive,
  setHandleUpdateNext,
  handleUpdateNext,
}) => {
  const [isApprovedState, setIsApprovedState] = useState([]);

  const [customErrors, setCustomErrors] = useState({});
  const [gstVerified, setGstVerified] = useState(null);
  const [GSTStatus, setGSTStatus] = useState(null);
  const associatedAccountRef = useRef(null);
  const [activeTab, setActiveTab] = useState("Active");
  const dispatch = useDispatch();
  const [GSTLinked, setGSTLinked] = useState(true);
  const [GSTLinkedMessage, setGSTLinkedMessage] = useState(false);
  const [newData, setNewData] = useState({
    gstin: "",
  });
  const { gstVerificationData, gstVerificationLoading } = useSelector(
    (state) => state.sharedResources,
  );

  const [gstTempData, setGstTempData] = useState(null);
  const currentAccount = accountData || {};
  const gstNumber = currentAccount?.gstin_detail;

  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);

  useEffect(() => {
    if (
      payload?.gstin?.length === GlobalConfiguration.gstLength &&
      !customErrors["gstin"]
    ) {
      setGSTStatus(Validation.allowedGstin(payload.gstin));

      dispatch(verifyGST({ search_string: payload.gstin }));
    } else if (
      payload?.gstin?.length === GlobalConfiguration.gstLength &&
      customErrors["gstin"]
    ) {
      setGSTStatus(Validation.allowedGstin(payload.gstin));
    }
  }, [payload.gstin]);

  useEffect(() => {
    if (!gstVerificationLoading) {
      if (gstVerificationData?.status === true) {
        setGstVerified(true);
      } else if (gstVerificationData?.status === false) {
        setGstVerified(false);
      }
    }
  }, [gstVerificationData, gstVerificationLoading]);

  useEffect(() => {
    if (
      gstVerificationLoading ||
      ((isLinkedAccount || alreadyLinked) && verifiedPan)
    ) {
      return;
    }

    if (payload?.gstin?.length === GlobalConfiguration.gstLength) {
      let aa = payload.gstin.substring(
        2,
        payload.gstin.length - GlobalConfiguration.accountminLength,
      );
      if (aa === panNumber && gstVerificationData?.status === true) {
        setGSTStatus(true);
        setGstVerified(true);
        setGSTLinked(true);
      } else {
        setGSTStatus(false);
        setGstVerified(false);
        if (aa != panNumber && gstVerificationData?.status === true) {
          setGSTLinked(false);
        }
        BenEnableNextButton(true);
      }
    } else if (!payload?.gstin && verifiedPan && !verifyPANisLoading) {
      setGSTStatus(null);
    }
  }, [
    gstVerificationData,
    GSTStatus,
    gstVerified,
    payload.gstin,
    verifyPANisLoading,
    isLinkedAccount,
    alreadyLinked,
    verifiedPan,
    gstVerificationLoading,
  ]);

  useEffect(() => {
    if (activeTab === "Active") {
      setIsActive(false);
      setIsApproved(false);
      setIsArchived(false);
      setIsDennied(false);
      setIsPending(false);
    } else if (activeTab === "Inactive") {
      setIsActive(true);
      setIsApproved(false);
      setIsArchived(false);
      setIsDennied(false);
      setIsPending(false);
    }
  }, [activeTab]);

  useEffect(() => {
    // if ((isLinkedAccount || alreadyLinked) && verifiedPan) {
    //   return;
    // }

    let gstStoredData = gstTempData;
    let ActualGstno = currentAccount?.gstin_detail;
    let ActualPANno = currentAccount?.pan_no;
    let aa = payload?.gstin?.substring(
      2,
      payload?.gstin?.length - GlobalConfiguration.lengthCheckThree,
    );

    if (currentAccount?.id) {
      if (currentAccount?.gstin_detail == undefined) {
        if (
          !gstVerificationLoading &&
          gstStoredData != null &&
          payload.gstin != ""
        ) {
          if (
            payload.gstin?.length == GlobalConfiguration.gstLength &&
            GSTStatus
          ) {
            let aa = payload.gstin.substring(
              GlobalConfiguration.lengthCheckTwo,
              payload.gstin.length - GlobalConfiguration.lengthCheckThree,
            );
            if (aa === panNumber) {
              BenEnableNextButton(false);
              setGSTLinked(true);
            } else {
              BenEnableNextButton(true);
              setGSTLinked(false);
              setGSTLinkedMessage(false);
            }
          } else {
            BenEnableNextButton(true);
          }
        } else if (
          verifiedPan &&
          ActualPANno != panNumber &&
          (GSTStatus == null || !GSTStatus) &&
          payload.gstin?.length === GlobalConfiguration.lengthCheckZero
        ) {
          BenEnableNextButton(false);
        } else if (
          verifiedPan &&
          ActualPANno != panNumber &&
          GSTStatus &&
          payload.gstin?.length === GlobalConfiguration.gstLength
        ) {
          BenEnableNextButton(false);
        } else if (
          verifiedPan &&
          ActualPANno != panNumber &&
          payload.gstin?.length === GlobalConfiguration.lengthCheckZero
        ) {
          BenEnableNextButton(false);
        } else {
          BenEnableNextButton(true);
          setGSTLinked(false);
          setGSTLinkedMessage(false);
        }
      } else if (currentAccount?.gstin_detail) {
        if (!gstVerificationLoading) {
          if (ActualGstno != gstStoredData && gstStoredData != null) {
            if (
              payload.gstin?.length == GlobalConfiguration.gstLength &&
              GSTStatus
            ) {
              let aa = payload.gstin.substring(
                GlobalConfiguration.lengthCheckTwo,
                payload.gstin.length - GlobalConfiguration.lengthCheckThree,
              );
              if (aa === panNumber && GSTStatus) {
                BenEnableNextButton(false);
                setGSTLinked(true);
                setGSTLinkedMessage(true);
              } else if (aa !== panNumber && GSTStatus) {
                setGSTLinked(false);
                setGSTLinkedMessage(true);
                BenEnableNextButton(true);
              } else {
                BenEnableNextButton(true);
              }
            } else if (panNumber != ActualPANno && verifiedPan) {
              if (!GSTStatus) {
                BenEnableNextButton(true);
              } else {
                let aa = payload.gstin.substring(
                  2,
                  payload.gstin.length - GlobalConfiguration.lengthCheckThree,
                );
                if (aa === panNumber && GSTStatus) {
                  BenEnableNextButton(false);
                  setGSTLinked(true);
                  setGSTLinkedMessage(true);
                } else if (aa !== panNumber && GSTStatus) {
                  setGSTLinked(false);

                  BenEnableNextButton(true);
                } else {
                  BenEnableNextButton(true);
                }
              }
            } else {
              BenEnableNextButton(true);
              setGSTLinked(false);
              setGSTLinkedMessage(false);
            }
          } else if (
            GSTStatus == null &&
            !gstVerificationLoading &&
            panNumber != ActualPANno &&
            verifiedPan
          ) {
            BenEnableNextButton(false);
          } else if (GSTStatus && aa !== panNumber) {
            setGSTLinked(false);
          } else if ((GSTStatus || aa === panNumber) && gstVerified) {
            setGSTLinked(true);
            setGSTLinkedMessage(true);
          }
        } else if (ActualGstno == gstStoredData) {
          BenEnableNextButton(true);
          setGSTLinked(true);
          setGSTLinkedMessage(true);
        }
      }
    }
  }, [
    gstTempData,
    payload,
    GSTLinked,
    GSTStatus,
    gstVerified,
    gstVerificationLoading,
    currentAccount,
    isLinkedAccount,
    alreadyLinked,
    verifiedPan,
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      event.stopPropagation();
      if (
        associatedAccountRef.current &&
        !associatedAccountRef.current.contains(event.target)
      ) {
        setShowAccInfo(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [associatedAccountRef]);

  const [showDetail, setShowDetail] = useState(null);

  useEffect(() => {
    if (
      !beneLookLoading &&
      !verifyPANisLoading &&
      beneLookError === true &&
      verifiedPan &&
      panNumber?.length === GlobalConfiguration.panLength
    ) {
      setShowDetail(true);
    } else {
      setShowDetail(false);
    }
  }, [
    beneLookLoading,
    verifyPANisLoading,
    beneLookError,
    verifiedPan,
    panNumber,
  ]);

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "gstin") return Validation.allowedGstin(value);
    return true;
  };
  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };

    if (name === "gstin")
      errors = Validation.validateGstin(name, value, errors);
    setCustomErrors(errors);
  };

  const isGstInputDisabled =
    type === "editFlow" &&
    (verifiedPan !== true ||
      panNumber?.length !== GlobalConfiguration.panLength);

  const handleChange = (e) => {
    if (isGstInputDisabled) return;

    const { name, value } = e.target;
    const newValue = modifyValue(name, value.replace(/[^a-zA-Z0-9]/g, ""));
    if (value) {
      setNewData({ [name]: value });
    }
    setNewData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (
        value.trim() === "" &&
        value?.length === GlobalConfiguration.lengthCheckOne
      ) {
        return;
      }

      if (name === "gstin") {
        const len = newValue.length;

        setGSTLinked(false);
        setGstVerified(null);

        if (len === GlobalConfiguration.gstLength) {
          setGstTempData(newValue);
          setGSTStatus(false);
        } else if (
          len > GlobalConfiguration.lengthCheckZero &&
          len < GlobalConfiguration.gstLength
        ) {
          setGSTStatus(false);
        } else {
          setGstTempData(null);
          setGSTStatus(null);
        }
      }
    }
    setHandleUpdateNext(false);
  };

  useEffect(() => {
    if (payload.gstin?.length > 0 && gstVerificationData?.status === true) {
      let errors = { ...customErrors };
      delete errors["gstin"];
      setCustomErrors(errors);
      setGSTStatus(true);
    }

    if (payload.gstin?.length > 0 && gstVerificationData?.errors) {
      let errors = { ...customErrors };
      errors["gstin"] = gstVerificationData.errors;
      setCustomErrors(errors);
      setGSTStatus(false);
    }
  }, [gstVerificationData]);

  const navigate = useNavigate();
  const {
    unachivedLoadingPan,
    achivedLoadingPan,
    unachivedDataPan,
    achivedDataPan,
  } = useSelector((state) => state.verify);

  useEffect(() => {
    let haveApprovedLinked = beneLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id === previousId;
      },
    );

    let haveApprovedNotLinked = beneLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id !== previousId;
      },
    );

    if (haveApprovedLinked && haveApprovedNotLinked) {
      const newData = [...haveApprovedLinked, ...haveApprovedNotLinked];
      setIsApprovedState(newData);
    }
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.find((val) => {
      if (val?.id === previousId) {
        setPreviousBankNo(val?.bank_acc_no);
      }
    });
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.find((val) => {
      if (val?.id === previousId) {
        setGSTPanExist(val?.gstin_detail ? true : false);
      }
    });
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    if (!achivedLoadingPan) {
      if (achivedDataPan?.status === true) {
        dispatch(panLookUp({ pan_number: panNumber }));

        CommonToast({
          text: "Account archived successfully",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        dispatch(resetPanArchived());
      } else if (achivedDataPan?.status === false) {
        if (achivedDataPan?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned");
        } else {
          CommonToast({
            text: Object.values(achivedDataPan?.errors)[0][0],
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          dispatch(resetPanArchived());
        }
      }
    }
  }, [achivedDataPan]);

  useEffect(() => {
    if (!unachivedLoadingPan) {
      if (unachivedDataPan?.status === true) {
        dispatch(panLookUp({ pan_number: panNumber }));

        CommonToast({
          text: "Account unarchived successfully",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setAccountType({ type: "", id: "" });
        dispatch(resetPanUnarchived());
      } else if (unachivedDataPan?.status === false) {
        if (unachivedDataPan?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned");
        } else {
          CommonToast({
            text: Object.values(unachivedDataPan?.errors)[0][0],
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          dispatch(resetPanUnarchived());
        }
      }
    }
  }, [unachivedDataPan]);

  useEffect(() => {
    if (gstVerificationData?.gstin_details?.business_name) {
      setPayload({
        ...payload,
        gst_org_name: gstVerificationData?.gstin_details?.business_name,
      });
    }
  }, [gstVerificationData]);

  if (
    GSTPanExist &&
    payload?.gstin?.length === GlobalConfiguration.lengthCheckZero &&
    !(isLinkedAccount || alreadyLinked)
  ) {
    BenEnableNextButton(true);
  }

  return (
    <div
      className={`benePan_Main_edit_pan  lg:gap-gap-xl    pb-padding-xl overflow-y-auto overflow-x-hidden `}
    >
      <div
        className={`w-full  px-padding-md lg:px-padding-base  lg:w-width-md ${openAssociatePopup ? "" : "z-z-index-base"}`}
      >
        {(isLinkedAccount || alreadyLinked) &&
        verifiedPan &&
        !beneLookLoading ? (
          <div
            className=" p-padding-md bg-emphasis rounded-border-radius-md mb-margin-md flex  gap-gap-sm items-center
          "
          >
            <img
              className="w-icon-md h-icon-md"
              src={ICONS.ERROR_WITH_WHITE_CIRCLE}
              alt="error_with_white_circle"
            />
            <p className=" text-text-secondary text-font-xs ">
              The bank account is already linked to the PAN provided. To
              proceed, update either the bank details or the PAN associated with
              the profile.
            </p>
          </div>
        ) : nonArchive ? (
          <div className="new_message_text_block_nonarchiveEdit mt-margin-lg Qsmd:mt-margin-base">
            <img
              src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
              alt="info"
            />
            <p className="mt-margin-sm">
              Archiving this account is disabled. As you're currently editing
              this account, archiving cannot be performed.
            </p>
          </div>
        ) : hideBlock ? (
          <div className="new_message_text_block mt-margin-lg Qsmd:mt-margin-base">
            <img
              src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
              alt="info"
            />
            <p>To unblock this account, please contact customer support</p>
          </div>
        ) : hideCreate ? (
          <div className="new_message_text_block mt-margin-lg Qsmd:mt-margin-base">
            <img
              src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
              alt="info"
            />
            <p>
              Creating a new account adds it to the active accounts for the
              provided PAN
            </p>
          </div>
        ) : beneLookData?.status &&
          panNumber?.length === GlobalConfiguration.panLength &&
          verifiedPan &&
          !associatedPan &&
          currentAccount?.pan_no !== panNumber ? (
          <></>
        ) : null}

        {gstNumber ? (
          <div className=" p-padding-md bg-emphasis rounded-border-radius-md mb-margin-md ">
            <h5 className=" text-text-primary text-font-sm font-semibold">
              Since GST and PAN are linked
            </h5>
            <div className="flex gap-gap-sm  items-center">
              <img
                src={ICONS.ERROR_WITH_WHITE_CIRCLE}
                alt="error_with_white_circle"
                className="w-icon-md h-icon-md"
              />
              <ul className="list-disc text-font-xs text-text-secondary pl-padding-button-l ">
                <li className="my-margin-sm">
                  To edit PAN, the associated GST must also be provided.
                </li>
                <li>
                  GST can only be replaced with other GSTs that are associated
                  with the provided PAN.
                </li>
              </ul>
            </div>
          </div>
        ) : null}

        <div className="dividepan_edit_pan h-auto">
          <PanDetails
            verifiedPan={verifiedPan}
            verifyPANisLoading={verifyPANisLoading}
            panNumber={panNumber}
            handlePanChange={handlePanChange}
            panDetails={panDetails}
          />
        </div>

        <div
          className="dividepan_edit_pan h-auto rounded-border-radius-md"
          style={{
            backgroundColor: isGstInputDisabled ? "var(--Blue-3)" : "",
            opacity: isGstInputDisabled
              ? "var(--light-opacity)"
              : "var(--base-opacity)",
          }}
        >
          <GstDetails
            GSTStatus={GSTStatus}
            gstVerified={gstVerified}
            beneVerifyGST={gstVerificationData}
            isGSTLoading={gstVerificationLoading}
            GSTLinked={GSTLinked}
            GstNumber={payload.gstin}
            setShowPopup={setShowPopup}
            handleChange={handleChange}
            isInputDisabled={isGstInputDisabled}
          />
        </div>
      </div>

      <div
        className={`w-width-full flex flex-col h-auto lg:w-width-md relative Qlg:p-padding-base p-padding-md ${openAssociatePopup ? "" : "z-z-index-base"}`}
      >
        {verifiedPan === true &&
          beneLookLoading === false &&
          verifyPANisLoading === false &&
          shouldNextBtnBeEnabled &&
          !updateActive && (
            <div style={{ overflow: "hidden" }}>
              <div
                className={
                  verifiedPan === false ? "" : "animate-slideInFromRight"
                }
              >
                <ConfirmBtnAccCreation
                  type="pan"
                  status={beneLookData?.status}
                  lookupNext={handleUpdateNext}
                  GSTStatus={GSTStatus}
                  isGSTLoading={gstVerificationLoading}
                  selected={ICONS?.SELECTED_WITH_GREEN_CIRCLE}
                  not_selected={ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE}
                  handleClick={() => {
                    setHandleUpdateNext(true);
                  }}
                />
              </div>
            </div>
          )}
        <ActiveInactiveAssociatePopup
          flow={
            verifiedPan === false
              ? "hideAssociate"
              : (isLinkedAccount || alreadyLinked) && verifiedPan
                ? "Existing"
                : showDetail
                  ? "notFoundPan"
                  : !showDetail && verifiedPan
                    ? "Pan"
                    : "defaultPan"
          }
          dropDownNo={GlobalConfiguration?.lengthCheckTwo}
          pan={payload?.panNumber}
          ifsc={isBankLinkedToThisPan?.ifsc_code}
          bank={isBankLinkedToThisPan?.bank_acc_no}
          accActiveInactiveState={accActiveInactiveState}
          setAccActiveInactiveState={setAccActiveInactiveState}
          currentAssociate={currentAssociate}
          setCurrentAssociate={setCurrentAssociate}
          openAssociatePopup={openAssociatePopup}
          setOpenAssociatePopup={setOpenAssociatePopup}
          activeAssociateId={id}
          panLength={panNumber.length}
        />
      </div>
    </div>
  );
};

export default FieldForcePanDetails;
